import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { numberLocale } from './language';

import enCommon from '@/locales/en/common.json';
import deCommon from '@/locales/de/common.json';
import enAuth from '@/locales/en/auth.json';
import deAuth from '@/locales/de/auth.json';
import enDashboard from '@/locales/en/dashboard.json';
import deDashboard from '@/locales/de/dashboard.json';
import enSettings from '@/locales/en/settings.json';
import deSettings from '@/locales/de/settings.json';
import enEnforcement from '@/locales/en/enforcement.json';
import deEnforcement from '@/locales/de/enforcement.json';
import enPricing from '@/locales/en/pricing.json';
import dePricing from '@/locales/de/pricing.json';
import enOptimization from '@/locales/en/optimization.json';
import deOptimization from '@/locales/de/optimization.json';
import enPerformance from '@/locales/en/performance.json';
import dePerformance from '@/locales/de/performance.json';
import enProducts from '@/locales/en/products.json';
import deProducts from '@/locales/de/products.json';
import enRoadmap from '@/locales/en/roadmap.json';
import deRoadmap from '@/locales/de/roadmap.json';
import enWizard from '@/locales/en/wizard.json';
import deWizard from '@/locales/de/wizard.json';
import enCaseStudy from '@/locales/en/caseStudy.json';
import deCaseStudy from '@/locales/de/caseStudy.json';
import enWorkbench from '@/locales/en/workbench.json';
import deWorkbench from '@/locales/de/workbench.json';
import enUploadConfirm from '@/locales/en/uploadConfirm.json';
import deUploadConfirm from '@/locales/de/uploadConfirm.json';
// Google-Ads-Lesepfad (Spec AP3/AP4). Der Namespace wird JETZT angelegt, obwohl
// die Copy vorerst nur englisch ist (Spec F3): Google verlangt das Demo-Video zur
// Scope-Freigabe ohnehin auf Englisch. Die de-Datei traegt deshalb absichtlich
// dieselben englischen Werte -- so ist das Verhalten in beiden Sprachen
// deterministisch, und die spaetere deutsche Fassung ist eine reine Uebersetzung
// statt eines Umbaus.
import enAdsPerformance from '@/locales/en/adsPerformance.json';
import deAdsPerformance from '@/locales/de/adsPerformance.json';
// B2B-Bestaetigungs-Dialog vor dem Stripe-Checkout (Paket B Umsatzsteuer).
import enCheckout from '@/locales/en/checkout.json';
import deCheckout from '@/locales/de/checkout.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        settings: enSettings,
        enforcement: enEnforcement,
        pricing: enPricing,
        optimization: enOptimization,
        performance: enPerformance,
        products: enProducts,
        roadmap: enRoadmap,
        wizard: enWizard,
        caseStudy: enCaseStudy,
        workbench: enWorkbench,
        uploadConfirm: enUploadConfirm,
        adsPerformance: enAdsPerformance,
        checkout: enCheckout,
      },
      de: {
        common: deCommon,
        auth: deAuth,
        dashboard: deDashboard,
        settings: deSettings,
        enforcement: deEnforcement,
        pricing: dePricing,
        optimization: deOptimization,
        performance: dePerformance,
        products: deProducts,
        roadmap: deRoadmap,
        wizard: deWizard,
        caseStudy: deCaseStudy,
        workbench: deWorkbench,
        uploadConfirm: deUploadConfirm,
        adsPerformance: deAdsPerformance,
        checkout: deCheckout,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common', 'auth', 'dashboard', 'settings', 'enforcement',
      'pricing', 'optimization', 'performance', 'products', 'roadmap', 'wizard', 'caseStudy', 'workbench', 'uploadConfirm',
      'adsPerformance', 'checkout',
    ],
    supportedLngs: ['en', 'de'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'feed-optimizer-lang',
      caches: ['localStorage'],
    },
  });

/** Returns the BCP 47 locale string matching the current app language. */
export function getDateLocale(): string {
  return numberLocale(i18n.language);
}

export default i18n;
